/* const cachingStrategies = {
	user: "user",
	public: "public",
	role: "role",
}; */

enum cachingStrategies {
	user = "user",
	public = "public",
	role = "role",
}

export default cachingStrategies;
